module["exports"] = [
  "0726######",
  "0723######",
  "0722######",
  "0721######",
  "0720######",
  "0728######",
  "0729######",
  "0730######",
  "0739######",
  "0738######",
  "0737######",
  "0736######",
  "0735######",
  "0734######",
  "0733######",
  "0732######",
  "0731######",
  "0780######",
  "0788######",
  "0753######",
  "0754######",
  "0755######",
  "0756######",
  "0757######",
  "0758######",
  "0759######",
  "0748######",
  "0747######",
  "0746######",
  "0740######",
  "0741######",
  "0742######",
  "0743######",
  "0744######",
  "0745######",
  "0711######",
  "0727######",
  "0725######",
  "0724######",
  "0786######",
  "0760######",
  "0761######",
  "0762######",
  "0763######",
  "0764######",
  "0765######",
  "0766######",
  "0767######",
  "0785######",
  "0768######",
  "0769######",
  "0784######",
  "0770######",
  "0772######",
  "0771######",
  "0749######",
  "0750######",
  "0751######",
  "0752######"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ro/cell_phone/formats.js
// module id = 3466
// module chunks = 1609